<template>
  <v-layout row wrap  >
    <v-snackbar v-model="snackbar" bottom color="success">
      Data salva com sucesso!
      <v-btn flat color="black" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-flex xs12 mb-3>
      <h2>Olá, {{$store.state.user.username }}</h2>
    </v-flex>
      <!-- Mediador do MakerLab -->
    <div v-if="isMakerlab && $store.state.selectedRole.name === 'Mediador'">
      <v-layout xs12 row wrap >
      <v-progress-circular indeterminate color="primary" v-if="!showCard"></v-progress-circular>
        <v-layout align-start  row fill-height wrap v-if="showCard && listaproj.length > 0">
          <v-flex xs6 v-for="(proj,i) in listaproj" :key="proj.id" class="pa-2">
            <v-card  >
              <v-card-title>
                <v-flex xs12>
                  Projeto: 
                  <v-chip
                    label
                    color="blue"
                    outline
                  >{{proj.name}}</v-chip>
                </v-flex>
                <v-flex xs6>
                  Turma: 
                  <v-chip
                    label
                    color="orange"
                    outline
                  >{{proj.turma_name}}</v-chip>
                  </v-flex>
                <v-flex xs6>
                  Unidade: 
                  <v-chip
                    label
                    color="orange"
                    outline
                  >{{proj.unidade_name}}</v-chip>
                  </v-flex>
              </v-card-title>
              <v-card-text>
                <v-layout row>
                  <v-flex xs11 v-if="aberto">

                <v-tooltip bottom>
                    <span slot="activator">
                    <v-progress-linear  v-if="showBarra" v-model="valueDeterminate[i]"></v-progress-linear>
                    </span>
                    <span>
                    Progressão das atividades
                    </span>
                </v-tooltip>
                  </v-flex>
                  <v-flex>
                    <v-icon
                      v-if="!ativShow[i]"
                      size="25"
                      @click="show(i)"
                      style="float: right; margin-top: 5px" 
                    >
                      keyboard_arrow_down
                    </v-icon>    
                    <v-icon
                      v-if="ativShow[i]"
                      size="25"
                      @click="show(i)"
                      style="float: right; margin-top: 5px" 
                    >
                      keyboard_arrow_up
                    </v-icon>          
                  </v-flex>
                </v-layout>
                <v-layout row v-if="ativShow[i]" wrap>
                  <v-flex xs12 v-for="ativ in atividade[i]" :key="ativ.index" wrap >
                    <v-layout row>
                      <v-flex xs6>
                        <v-checkbox
                          v-model="showDate[ativ.id]"
                          :label="ativ.title"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs6 >
                      <div v-if="showDate[ativ.id]" >
                        <v-text-field
                          single-line
                          mask="##/##/####"
                          label="Finalizado em"
                          persistent-hint
                          style="width: 80%"
                          hint="DD/MM/AAAA"
                          @keyup.enter.prevent="$event.target.blur()"
                          v-model="ativ.data_completude"
                          @blur="saveDate(ativ, ativ.data_completude)"
                        ></v-text-field>
                      </div>
                    </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex class="mt-3">
                    Evidências para avaliar:
                  <v-chip
                    label
                    color="red"
                    outline
                    v-if="showNumber && numberFoco[proj.id] != 0"
                    @click="goTo(proj.id)"
                  >{{numberFoco[proj.id]}}</v-chip>
                  <v-chip
                    label
                    color="primary"
                    outline
                    v-if="showNumber && numberFoco[proj.id] == 0"
                    @click="goTo(proj.id)"
                  >{{numberFoco[proj.id]}}</v-chip>
                    <v-icon
                      v-if="!showAluno[i]"
                      size="25"
                      @click="AlunoShow(i)"
                      style="float: right; margin-top: 5px" 
                    >
                      keyboard_arrow_down
                    </v-icon>    
                    <v-icon
                      v-if="showAluno[i]"
                      size="25"
                      @click="AlunoShow(i)"
                      style="float: right; margin-top: 5px" 
                    >
                      keyboard_arrow_up
                    </v-icon>         
                  </v-flex>
                </v-layout>
                <v-layout v-if="showAluno[i]">
                  <v-flex xs12 v-for="aluno in termometro[i]" :key="aluno.index">
                  <v-chip
                    label
                    :color="colorAluno(aluno, i)"
                    outline
                  >{{aluno.username}}</v-chip>                
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout v-else>
          <v-flex xs12 v-if="showCard">
          <h2>O mediador não possui projeto!</h2>
          <br>
          <p>Acesse o cadastro de projetos.</p>
          </v-flex>
        </v-layout>
      </v-layout>
    </div>

      <!-- Quando é MundoMaker -->
    <div v-if="!isMakerlab">
      <div v-if="$store.state.selectedRole.name === 'Admin'">
        <v-layout row>
          <v-flex v-for="unidade in $store.state.user.unidade" :key="unidade.name" >
              <v-card width="94%" class="ma-2">
                <v-card-title>
                  <v-layout align-center justify-center row fill-height >
                    <p>
                      <strong style="font-size: 1.2rem" @click="gotounidade(unidade.slug)">Unidade : {{ unidade.name }}</strong>
                      <v-icon
                        size="25"
                        @click="urlCalendar(unidade.slug)" 
                        style="margin-left: 25px"
                      >
                        calendar_today
                      </v-icon>
                    </p>
                  </v-layout>
                </v-card-title>
                <v-card-text>
                  <p>
                    <strong style="font-size: 1.2rem">Responsável : </strong> 
                    <span v-if="unidade.responsavel">{{ unidade.responsavel }}</span>
                    <span v-else > Nenhum</span> 
                  </p> 
                  <p>
                    <strong style="font-size: 1.2rem">Mediadores : </strong>
                    <v-chip label
                    v-for="med in unidade.mediadores" :key="med.username"
                    desable 
                    @click="gotouser(med.username)"
                    color='amber'
                    outline>
                        {{ med.username }}
                    </v-chip>
                  </p>
                  <p>
                    <strong style="font-size: 1.2rem">Programas : </strong>
                    <v-chip label
                    v-for="prog in unidade.programas" :key="prog.name"
                    desable 
                    @click="gotoprograma(prog.slug)"
                    color='blue'
                    outline>
                    {{ prog.name }}
                    </v-chip>
                  </p> 
                </v-card-text>
              </v-card>
          </v-flex>
        </v-layout>
      </div>
      <v-flex xs6 >
        <fade-transition :duration="800" >
          <v-card width="94%" v-if="calend.length > 0">
            <v-card-title>
              <v-layout align-center justify-center row fill-height >
                <strong style="font-size: 1.2rem">Suas próximas atividades</strong>
                <v-icon
                  size="25"
                  @click="gotocalendario" 
                  style="margin-left: 25px"
                >
                  calendar_today
                </v-icon>
              </v-layout>
            </v-card-title>
            <v-card-text v-for="aulas in calend.slice(0, 5)" :key="aulas.title" style="margin-top: -15px">
              <strong style="font-size: 1.2rem">Aula :</strong> {{ aulas.title }}<br>
              <strong style="font-size: 1.2rem">Data :</strong> {{ aulas.dt_inicio | moment("DD/MM/YYYY")}}<br>
              <strong style="font-size: 1.2rem">Horário :</strong> {{ aulas.dt_inicio | moment("H:mm")}}          
            </v-card-text>
          </v-card>
        </fade-transition>
      </v-flex>
      <v-flex xs6 >
        <fade-transition group :duration="800">
          <v-card v-if="$store.state.selectedRole.name !== 'Admin'" key="5">
            <v-card-title>
              <v-layout align-center justify-center row fill-height >
                <strong style="font-size: 1.2rem">Informações</strong>
              </v-layout>
            </v-card-title>
            <v-card-text>
              <p>
                <strong style="font-size: 1.2rem">Unidades : </strong>
              <!-- <a href="#" 
                > -->
              <!-- @click.prevent="goToUnidade(un.slug)"> -->
                <v-chip label
                v-for="un in $store.state.user.unidade"
                :key="un.name"
                @click="gotounidade(un.slug)"
                desable 
                color='amber'
                outline>
                    {{un.name}}
                </v-chip>
              </p>
              <div v-if="$store.state.selectedRole.name === 'Aluno'">
                <p>
                  <strong style="font-size: 1.2rem">Mediador(a) : </strong>
                <!-- <a href="#" 
                  > -->
                <!-- @click.prevent="goToUnidade(un.slug)"> -->
                  <v-chip label
                  desable 
                  color='amber'
                  outline>
                    {{ userdetail.mediador}}
                  </v-chip>
                </p> 
                <p>
                  <strong style="font-size: 1.2rem">Projeto atual : </strong> 
                  <v-avatar @click="gotoprojeto(projAtual.id)">
                    <img :src="projAtual.image" alt="">
                  </v-avatar>
                  <strong>{{ projAtual.name}}</strong>
                </p>
              </div>
              <div v-if="$store.state.selectedRole.name === 'Mediador'">
                <!-- <p v-if="listaproj.length > 0">
                  <strong style="font-size: 1.2rem">Projetos :  </strong>
                  <span v-for="lista in listaproj" :key="lista.name"> 
                    <v-avatar style="margin-left: 10px">
                    <img :src="lista.image" alt="">
                  </v-avatar>{{ '\xa0\xa0' + lista.name }}</span>
                </p> -->
              </div>
              <div v-if="alunos.length > 0">
                <p>
                  <strong style="font-size: 1.2rem">Seus alunos : </strong>
                <!-- <a href="#" 
                  > -->
                <!-- @click.prevent="goToUnidade(un.slug)"> -->
                  <v-chip 
                    v-for="student in alunos"
                    :key="student.username"
                    desable 
                    @click="gotouser(student.username)"
                    color='blue'
                    outline>
                    <v-avatar>
                      <img :src="student.profilePic" alt="">
                    </v-avatar>
                        {{student.username}}
                  </v-chip>
                </p>        
              </div>
            </v-card-text>
          </v-card>
        </fade-transition>
      </v-flex>
      <v-spacer></v-spacer>
    </div>


   
  </v-layout>
    
</template>
<script>
import api from '@/api'
import {FadeTransition} from 'vue2-transitions'
export default {

  components: {
    FadeTransition
  },

  data () {
    return {
      calend: {},
      ativShow: [false, false, false, false, false, false, false, false, false],
      showCard: false,
      snackbar: false,
      showNumber: false,
      showBarra: false,
      showAluno: [false, false, false, false, false, false, false, false, false],
      valueDeterminate: [],
      alunos: [],
      showDate: [],
      atividade: [],
      userdetail: [],
      projAtual: [],
      listaproj: [],
      numberFoco: [],
      turma: [],
      i: 0,
      menu: false,
      aberto: false,
      dateAtiv: '',
      termometro: []
    }
  },

  mounted () {
    var ano = new Date().getFullYear()
    var mes = new Date().getMonth() + 1
    var dia = new Date().getUTCDate()
    var datahoje = ano + '-' + mes + '-' + dia
    api.request('GET', 'calendario?username=' + this.$store.state.user.username + '&dtinicio=' + datahoje).then(response => {
      this.calend = response.data
    }).catch(function (error) {
      console.log(error)
    })
    this.$watch('$store.state.selectedRole.name', function () {
      this.verifica()
    })

    this.verifica()
  },
  computed: {
    // talvez seja necessário
    // currentRole () {
    //   console.log(this.$store.state.selectedRole.name)
    //   if (this.$store.state.selectedRole) {
    //     return this.$store.state.selectedRole.name
    //   } else {
    //     return ''
    //   }
    // },
    isMakerlab () {
      return this.$store.state.company.makerlab;
    },
    verifica () {
      if (this.$store.state.selectedRole.name === 'Mediador') {
        this.getStudents()
        this.projectlist()
      }
      if (this.$store.state.selectedRole.name === 'Aluno') {
        this.projetoatual()
      }
      if (this.$store.state.selectedRole.name === 'Admin') {
      }
      this.getuserdetails()
    }
  },
  methods: {
    getStudents () {
      api.request('GET', 'search-user?mediador__username=' + this.$store.state.user.username).then(response => {
        this.alunos = response.data
      })
    },
    getuserdetails () {
      api.request('GET', 'users/' + this.$store.state.user.id + '/').then(resp => {
        this.userdetail = resp.data
        this.$store.commit('SET_DETAILS', resp.data)
        // console.log(this.$store.state.user)
      })
    },
    projetoatual () {
      if (this.$store.state.user.current_project !== null) {
        api.request('GET', 'projetos/' + this.$store.state.user.current_project + '/').then(resp => {
          this.projAtual = resp.data
        })
      }
    },
    projectlist () {
      this.showCard = false
      api.request('GET', 'projetos/?moderador=' + this.$store.state.user.id).then(resp => {
        this.listaproj = resp.data
      }).then(() => {
        if (this.listaproj.length > 0) {
          for (let index = 0; index < this.listaproj.length; index++) {
            api.request('GET',
                'evidencias/?page=1&project=' + this.listaproj[index].id + '&is_focus_evidence=true&is_not_evaluated=true'
              ).then(data => {
                console.log('data das', data.data.count)
                this.numberFoco[this.listaproj[index].id] = data.data.count
              })
            api.request('GET', 'atividade/?projeto__id=' + this.listaproj[index].id).then(resp => {
              this.atividade[index] = resp.data
              var completude = 0
              for (let i = 0; i < this.atividade[index].length; i++) {
                if (this.atividade[index][i].data_completude !== null) {
                  this.showDate[this.atividade[index][i].id] = true
                  completude = completude + 1
                  this.atividade[index][i].data_completude = this.formatDate(this.atividade[index][i].data_completude)
                }
              }
              this.valueDeterminate[index] = (100 * completude) / this.atividade[index].length
            }).then(() => {
              api.request('GET', 'projetos/' + this.listaproj[index].id + '/evid_foco_aluno/').then(resp => {
                this.termometro[index] = resp.data
              })
            })
            this.$store.commit('SET_NUMBER', this.numberFoco)
            this.$store.commit('SET_LISTPROJ', this.listaproj)
          }
          this.showCard = true
          setTimeout(() => {
            this.showCard = false
            for (let index = 0; index < this.ativShow.length; index++) {
              this.ativShow[index] = true
            }
            for (let index = 0; index < this.ativShow.length; index++) {
              this.ativShow[index] = false
            }
            for (let index = 0; index < this.showAluno.length; index++) {
              this.showAluno[index] = true
            }
            for (let index = 0; index < this.showAluno.length; index++) {
              this.showAluno[index] = false
            }
            this.aberto = true
            this.numberFoco = this.numberFoco
            this.termometro = this.termometro
            this.valueDeterminate = this.valueDeterminate
            this.showNumber = true
            this.showBarra = true
            this.showCard = true
            this.$emit('sino', this.numberFoco.reduce((a, b) => a + b, 0))
            console.log('number', this.numberFoco)
          }, 700);
        } else {
          this.showCard = true
        }
      })
    },
    goTo (id) {
      this.$store.commit('SET_CENTRAL', id)
      this.$router.push('/central')
    },
    gotounidade (slug) {
      if (this.$store.state.selectedRole.name !== 'Aluno') {
        let name = '/unidades/' + slug
        this.$router.push(name)
      }
    },
    gotoprograma (slug) {
      let name = '/programas/' + slug
      this.$router.push(name)
    },
    gotouser (username) {
      let name = '/usuarios/' + username
      this.$router.push(name)
    },
    gotocalendario (username) {
      let name = '/calendario/usuario/' + this.$store.state.user.username
      this.$router.push(name)
    },
    gotoprojeto (id) {
      let name = '/projetos/' + id
      this.$router.push(name)
    },
    goToCadastro () {
      let name = 'projetos'
      this.$router.push(name)
    },
    urlCalendar (slug) {
      this.$router.push('/calendario/unidade/' + slug)
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    RevertFormatDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month}-${day}`
    },
    checkBoxing (ativ) {
      if (ativ.data_completude !== null) {
        this.showDate[ativ.id] = true
        return true
      }
    },
    runScript (e) {
      alert(e.keyCode)
      if (e.keyCode === 13) {
        alert('enter')
        return false;
      }
    },
    saveDate (ativ) {
      ativ.data_completude = [ativ.data_completude.slice(0, 2), '/', ativ.data_completude.slice(2)].join('')
      ativ.data_completude = [ativ.data_completude.slice(0, 5), '/', ativ.data_completude.slice(5)].join('')
      var x = this.RevertFormatDate(ativ.data_completude)
      var payload = {
        'data_completude': x
      }
      api.request('PATCH', 'atividade/' + ativ.id + '/', payload).then(() => {
        this.snackbar = true
        setTimeout(() => {
          this.snackbar = false
        }, 1500);
        this.projectlist()
      })
    },
    show (i) {
      this.showCard = false
      if (this.ativShow[i] === false) {
        this.ativShow[i] = true
      } else {
        this.ativShow[i] = false
      }
      this.showCard = true
    },
    AlunoShow (i) {
      this.showCard = false
      if (this.showAluno[i] === false) {
        this.showAluno[i] = true
      } else {
        this.showAluno[i] = false
      }
      this.showCard = true
    },
    colorAluno (aluno, i) {
      var cor
      var quant = 0
      this.atividade[i].filter(el => {
        if (el.data_completude !== null) {
          quant = quant + 1
        }
      })

      if (quant <= 7) {
        if (aluno.num_tarefas <= (quant - 3)) {
          cor = 'red'
        }
        if (aluno.num_tarefas > (quant - 3)) {
          cor = 'yellow'
        }
        if (aluno.num_tarefas >= (quant - 1)) {
          cor = 'green'
        }
      }
      if (quant === 8) {
        if (aluno.num_tarefas >= 5) {
          cor = 'yellow'
        }
        if (aluno.num_tarefas < 5) {
          cor = 'red'
        }
      }
      if (quant === 9) {
        if (aluno.num_tarefas >= 7) {
          cor = 'yellow'
        }
        if (aluno.num_tarefas < 6) {
          cor = 'red'
        }
      }
      if (aluno.num_tarefas >= quant) {
        cor = 'green'
      }
      return cor
    }

  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue